import { MSSPriceSectionId } from '@ace-clublabs/common-membership-api-types';
import { useGlobalState } from '../../../../state/state';
import { ManageMembershipPriceCartItem } from '../ManageMembershipPriceCartItem';

export const AdmissionFeePriceCartItem = () => {
  const [priceCart] = useGlobalState('priceCart');
  const admissionFee = priceCart?.items?.find((p) => p.id === MSSPriceSectionId.ADMISSION_FEE);

  return admissionFee ? (
    <ManageMembershipPriceCartItem
      type="description"
      subtitle=""
      className="admission-fee-price-item"
      description={admissionFee?.description}
      price={admissionFee?.price}
    />
  ) : (
    <></>
  );
};
